import { ShiftSeriesCreate } from '@libs/models/shifts/series';
import { request } from '../../request';

export async function createShiftSeries(data: ShiftSeriesCreate): Promise<SeriesCreationResult[]> {
  const response = await request.post<SeriesCreationResult[]>('/v2/shifts/series', {
    ...data,
    specialityId: data.specialtyId || null,
    subDepartmentNodeId: data.subDepartmentNodeId || null,
    departmentNodeId: data.departmentNodeId || null,
    startDate: { dateTime: data.startDate, timeZone: data.timeZone },
    endDate: { dateTime: data.endDate, timeZone: data.timeZone },
    tags: data.tags.reduce((acc, tag) => {
      if (tag) {
        acc.push(tag + '');
      }
      return acc;
    }, [] as string[]),
  });
  return response.data;
}

type SeriesCreationResult = {
  id: string; //'shiftrecurrence-00000000000000000000000000';
  shiftIds: string[]; //['shift-00000000000000000000000000'];
};
